<template>
    <Link :href="link" type="button" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        {{ label }}
    </Link>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3';

export default {
    name: "SectionHeadingButton",
    components: {
        Link,
    },
    props: {
        label: {
            type: String,
        },
      link: {
            type: String,
            default: ''
        }
    },
}
</script>

<style scoped>

</style>
